import type { PersonJSON, PersonSummaryJSON } from '../../../api/model'
import type { Nullable, SelectOption } from '../../../common/types'

export const approverOptions = (
	eventPerson: Nullable<PersonJSON>,
	currentUser: Nullable<PersonJSON>,
	supervisorNrMap: { [personNumber: number]: PersonSummaryJSON },
) => {
	const options: SelectOption[] = []
	if (!eventPerson || !supervisorNrMap) return options
	const s1nr = eventPerson.controlDetails?.supervisor?.personNumber
	const s2nr = eventPerson.controlDetails?.supervisor2?.personNumber

	// add current user as default approver when not in personal profile
	const isPersonal = window.location.pathname.startsWith('/personal')
	if (!isPersonal && currentUser?.nr) {
		options.push({
			label: `${currentUser.nr}. ${currentUser.name}`,
			value: `${currentUser.nr}`,
		})
	}

	if (s1nr) {
		const supervisor = supervisorNrMap[s1nr]
		if (supervisor)
			options.push({
				label: `${supervisor.personNumber}. ${supervisor.personName}`,
				value: `${supervisor.personNumber}`,
			})
	}
	if (s2nr) {
		const supervisor = supervisorNrMap[s2nr]
		if (supervisor)
			options.push({
				label: `${supervisor.personNumber}. ${supervisor.personName}`,
				value: `${supervisor.personNumber}`,
			})
	}

	return options
}

export const getApproversForEvent = (
	eventApprovers: Array<{ id: number }>,
	supervisorNrMap: { [personNumber: number]: PersonSummaryJSON },
) =>
	eventApprovers.map((eventApprover) => {
		const supervisor = supervisorNrMap[eventApprover.id]
		return {
			label: `${supervisor.personNumber}. ${supervisor.personName}`,
			value: supervisor.personNumber,
		}
	})
